// <s-footer-nav> — footer link columns are accordions under 768px and always-open columns above.
// Each column is a native <details>; on desktop this keeps them open and makes the summary inert,
// on mobile they start closed. Listens to the breakpoint so rotating a tablet stays consistent.
class SFooterNav extends HTMLElement {
  #ac;
  #mq;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#mq = window.matchMedia('(min-width: 48rem)');
    this.#apply();
    this.#mq.addEventListener('change', () => this.#apply(), opts);

    this.addEventListener('click', (e) => {
      if (!this.#mq.matches) return;
      if (e.target.closest('summary')) e.preventDefault();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #apply() {
    const desktop = this.#mq.matches;
    for (const details of this.querySelectorAll('details')) {
      details.open = desktop;
      const summary = details.querySelector('summary');
      if (!summary) continue;
      if (desktop) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    }
  }
}

customElements.define('s-footer-nav', SFooterNav);
